import { Box, CircularProgress, Typography } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';

export type SaveState = 'idle' | 'saving' | 'saved' | 'error';

/** Tiny autosave status chip shown in the wizard header. */
export const SavedIndicator = ({ state, savedAt }: { state: SaveState; savedAt: string | null }) => {
  if (state === 'idle') return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      {state === 'saving' && <CircularProgress size={14} sx={{ color: 'inherit' }} />}
      {state === 'saved' && <CheckCircleOutline sx={{ fontSize: 16 }} />}
      <Typography variant="caption" sx={{ opacity: 0.85 }}>
        {state === 'saving' && 'Saving…'}
        {state === 'saved' && `Saved${savedAt ? ` at ${new Date(savedAt).toLocaleTimeString()}` : ''}`}
        {state === 'error' && 'Could not save — check your connection'}
      </Typography>
    </Box>
  );
};
